<template>
	<div class="rp-helpdesk__attachments" v-if="attachments && attachments.length">
		<div v-for="(item, i) in attachments" :key="i" class="attachment__item">
			<attachment-item
				:attachment="item"
			/>
		</div>
	</div>
</template>

<script>
import AttachmentItem from './AttachmentItem'
export default {
	name: 'Attachments',
	props: {
		attachments: {
			type: Array
		}
	},
	components: {
		AttachmentItem
	}
}
</script>

<style lang="scss">
	.rp-helpdesk__attachments{
		display: flex;
		flex-direction: column;
		// border-top: 1px solid #eeeeee;
		flex-wrap: wrap;
		.attachment__item {
			margin-top: 0.5rem;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			// width: 100%;
			&:hover{
				.attachment-icon {
					// background-color: #f3f4f8;
				}
			}
			.attachment-wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				// width: 80%;
			}
			.attachment-icon {
				// background-color: #fff;
				// border-radius: 2px;
				padding: 5px 10px;
				// box-shadow: 0px 1px 3px 1px #80808047;
				color: #2661a9db;
				font-size: 20px;
			}
			.attachment-name {
				p{
					word-wrap: break-word;
					// max-width: 80%;
					min-width: 50px;
					max-width: 250px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					text-decoration: underline;
					// font-weight: 600;
				}
				text-align: left;
				// width: 100%;
				// margin-top: 5px;
				
			}
			.attachment-downloading{
				// font-size: 20px;
			}
		}
	}
</style>

